import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import MissionImage from "../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73739.jpeg";
import VisionImage from "../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73741.jpeg";

const MissionVision = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
  autoplaySpeed: 5000, // Time in ms between slides
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Section>
      <Container>
        <Header>
          <Title>Our Mission & Vision</Title>
          {/* <Subtitle>Driving excellence in education and professional growth</Subtitle> */}
        </Header>

        <StyledSlider {...sliderSettings}>
          <Card>
            <CardImage src={MissionImage} alt="Mission Image" />
            <CardContent>
              <CardTitle>Our Mission</CardTitle>
              <CardDescription>
              To bridge the gap in access to quality education, research opportunities, funding, and competitive careers, particularly for the African community, which remains underrepresented in global research, innovation, and development.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardImage src={VisionImage} alt="Vision Image" />
            <CardContent>
              <CardTitle>Our Vision</CardTitle>
              <CardDescription>
              To be the leading consultancy empowering African students and young professionals to achieve their educational and career aspirations through enhanced communication skills, strategic mentorship, and increased awareness of global opportunities.
              </CardDescription>
            </CardContent>
          </Card>
        </StyledSlider>
      </Container>
    </Section>
  );
};

export default MissionVision;

// Styled Components
const Section = styled.section`
  background: linear-gradient(135deg, #eef2f3, #ffffff);
  padding: 80px 20px;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const Header = styled.div`
  margin-bottom: 50px;
`;

const Title = styled.h2`
 font-size: 2.5rem;
        font-weight: 800;
        color: #333333;
        margin-bottom: 1rem;
        text-transform: uppercase;
        letter-spacing: 1px;
        text-align:center;
        align-items:center;



  @media (max-width: 768px) {
    font-size: 2.4rem;
`;


const Subtitle = styled.p`
  font-size: 1.4rem;
  color: #666;
  margin-top: 10px;
`;

const StyledSlider = styled(Slider)`
  .slick-slide {
    display: flex;
    justify-content: center;
  }

  .slick-dots li button:before {
    color:rgb(14, 112, 193);
    font-size: 12px;
  }

  .slick-prev,
  .slick-next {
    color:rgb(13, 32, 235);
  }
`;

const Card = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 768px) {
    flex-direction: row;
    width: 90%;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;

  @media (min-width: 768px) {
    width: 40%;
  }
`;

const CardContent = styled.div`
  padding: 20px;
  text-align: left;

  @media (min-width: 768px) {
    padding: 30px;
  }
`;

const CardTitle = styled.h3`
  font-size: 2rem;
  color:rgb(9, 61, 182);
  margin-bottom: 15px;
`;

const CardDescription = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
`;
